import React from 'react';

import AdvisorIcon from 'components/Common/Icons/Advisor';
import HangerIcon from 'components/Common/Icons/Hanger';
import PackageReturnIcon from 'components/Common/Icons/PackageReturn';
import PadlockCardIcon from 'components/Common/Icons/PadlockCard';
import TruckIcon from 'components/Common/Icons/Truck';
import Trans from 'components/Common/Translation/Trans';
import { isFr as isFrFct } from 'services/currentCountry';

import styles from './CartReinsurance.module.scss';

export default function CartReinsurance(): JSX.Element {
  const isFr = isFrFct();
  const blocs: BlocType[] = [
    {
      image: <PadlockCardIcon />,
      message: renderBlocMessage('CART_REINSURANCE_PAYMENT_FACILITIES'),
    },
    {
      image: <HangerIcon />,
      message: renderBlocMessage('CART_REINSURANCE_PERSONAL_ACCOUNT'),
      isVisible: !isFr,
    },
    {
      image: <TruckIcon />,
      message: renderBlocMessage('CART_REINSURANCE_QUICK_DELIVERY'),
      isVisible: isFr,
    },
    {
      image: <PackageReturnIcon />,
      message: renderBlocMessage('CART_REINSURANCE_EASY_RETURN'),
    },
    {
      image: <AdvisorIcon />,
      message: renderBlocMessage('CART_REINSURANCE_NEED_HELP'),
    },
  ];

  function renderBlocMessage(label: string): JSX.Element {
    return (
      <Trans
        i18nKey={label}
        namespace={'checkout'}
        additionalComponents={{
          title: <p className={styles.title} />,
        }}
      />
    );
  }

  return (
    <div className={styles.container}>
      {blocs.map(({ image, message, isVisible = true }, i) => {
        if (isVisible) {
          return (
            <div key={`bloc-${i}`} className={styles.bloc}>
              {image}
              <div className={styles.message}>{message}</div>
            </div>
          );
        }
      })}
    </div>
  );
}

type BlocType = {
  image: JSX.Element;
  message: JSX.Element;
  isVisible?: boolean;
};
